import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from '../../ssr-services/api-config/api-config.service';
import { CacheService } from '../../ssr-services/cache/cache.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  protected http = inject(HttpClient);

  protected apiConfig = inject(ApiConfigService);

  protected cacheService = inject(CacheService);

  /**
   * Changes the user password
   * @param data
   * @returns
   */
  public changePassword(data: {
    currentPassword: string;
    newPassword: string;
    verifyPassword: string;
  }): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      this.apiConfig.url('subscribers/changePassword'),
      data
    );
  }

  /**
   * Sends OTP to email to start reset password flow
   * @param email
   * @returns
   */
  public requestResetPassword(email: string): Observable<{ message: string }> {
    const cacheContent = this.cacheService.cachedContent();
    return this.http.post<{ message: string }>(this.apiConfig.url('subscribers/forgot'), {
      email,
      customerId: cacheContent?.cache.customerId,
    });
  }

  /**
   * Resets the password through the otp
   * @param email
   * @param otp
   * @returns
   */
  public verifyOtpForResetPassword(email: string, otp: string): Observable<{ message: string }> {
    return this.http.get<{ message: string }>(
      this.apiConfig.url(`subscribers/reset/${otp}/${email}`)
    );
  }

  /**
   * Resets the password with new password
   * @param otp
   * @param password
   * @returns
   */
  public resetPassword(otp: string, password: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(this.apiConfig.url('subscribers/reset'), {
      newPassword: password,
      oldPassword: password,
      otp,
    });
  }
}
